import { AxiosInstance } from "axios";
import { type IPackages } from "@kunduz/data-access-payment-api";

export function getStudentPackagesBuilder(apiClient: AxiosInstance) {
  return async function getStudentPackages(): Promise<
    IPackages.IPaymentResponse[]
  > {
    const response = await apiClient.get(`/v4/students/packages/`);
    return response.data;
  };
}
